import { render } from "./PortfolioComponent.vue?vue&type=template&id=4fce1750"
import script from "./PortfolioComponent.vue?vue&type=script&lang=js"
export * from "./PortfolioComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__